import { useSelector } from "react-redux";
import GapRule from "./GapRule";
import NoGapRule from "./NoGapRule";
import {
  getDeepViewLineageEntry,
  isGapRuleBaPrefix,
} from "../../deepViewFieldMap";

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

const StageThree = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const lineageEntry = getDeepViewLineageEntry(deepViewData, columnKey);
  const isGapRule = isGapRuleBaPrefix(lineageEntry?.ba_prefix);

  return <>{isGapRule ? <GapRule columnKey={columnKey} /> : <NoGapRule />}</>;
};

export default StageThree;
